<template>
	<div>
		<div class="wd-p-20 wd-font-bold wd-font-18">安全设置</div>
		<div class="info wd-flex wd-row-left">
			<div class="head">
				<el-image :src="$wdpicurl(logininfo.myinfo.headpic,true)" class="wd-img-100 wd-border-round"></el-image>
			</div>
			<div class="wd-m-l-20">
				<div class="wd-font-18 wd-font-bold">{{logininfo.myinfo.mobile}}</div>
				<div class="wd-flex wd-row-left level wd-m-t-20 wd-m-b-20">
					<div class="a select">低</div>
					<div class="a">中</div>
					<div class="a">高</div>
				</div>
				<div class="wd-warning">建议你启动全部安全设置，以保障账户及资金安全</div>
			</div>
		</div>
		<div class="detail">
			<div class="row">
				<el-row class="wd-m-t-30 wd-m-b-30" :gutter="30">
					<el-col :span="5" class="a wd-text-center wd-font-20 wd-success">登录密码</el-col>
					<el-col :span="16" class="wd-theme-666">互联网账号存在被盗风险，建议您定期更改密码以及保护账户安全。</el-col>
					<el-col :span="3"><span class="wd-blue wd-cursor" @click="aaopt('Password')">修改</span></el-col>
				</el-row>
			</div>
			<div class="row">
				<el-row class="wd-m-t-30 wd-m-b-30" :gutter="30">
					<el-col :span="5" class="a wd-text-center wd-font-20 wd-success">支付密码</el-col>
					<el-col :span="16" class="wd-theme-666">申请提现或余额支付时，均须支付密码进行身份验证。</el-col>
					<el-col :span="3"><span  class="wd-blue wd-cursor" @click="aaopt('Paypassword')">设置</span></el-col>
				</el-row>
			</div>
			<div class="row">
				<el-row class="wd-m-t-30 wd-m-b-30" :gutter="30">
					<el-col :span="5" class="a wd-text-center wd-font-20 wd-success">手机验证</el-col>
					<el-col :span="16" class="wd-theme-666">您验证的手机：{{logininfo.myinfo.mobile}}若已丢失或停用，请立即更换，避免账户被盗。</el-col>
					<el-col :span="3"><span  class="wd-blue wd-cursor" @click="aaopt('Mobile')">修改</span></el-col>
				</el-row>
			</div>
		</div>
	</div>
</template>

<script>
	import{mapState} from 'vuex'
export default {
	computed:{...mapState(['logininfo'])},
	name: 'Safe',
	data() {
		return {};
	},
	methods: {
		aaopt(type) {
			console.log(type);
			this.$parent.setflag(type);
		}
	}
};
</script>

<style lang="scss" scoped>
.info {
	background: #fffef2;
	border: 1px solid #dadada;
	padding: 20px 10px;
	.head {
	}
	.level {
		.a {
			padding: 2px 20px;
			background: #dddddd;
			color: white;
			margin-right: 5px;
			&.select {
				background: #6fa13f;
			}
		}
	}
}
.detail {
	.row {
		overflow: hidden;
		line-height: 70px;
		border-bottom: 1px dashed #dcdfe6;
		.a {
			border-right: 1px dashed #dcdfe6;
		}
	}
}
</style>
